import classes from '@/components/Shares/Button.module.css';
import type { GameChallengesCardType } from '@/types';
import { useLingui } from '@lingui/react';
import { Avatar, Box, Button, Card, Divider, Group, Image, NumberFormatter, Stack, Text } from '@mantine/core';
export const GameChallengesCard: React.FC<GameChallengesCardType> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  return <Card w="100%" miw={{
    md: 205
  }} radius={5} bg="var(--bg-400)" p={{
    base: 10,
    lg: 20
  }} style={{
    cursor: 'pointer'
  }}>
      <Stack gap={12}>
        <Image src={props.imgCard} alt="games" w="100%" h={176} />
        <Text fz="xs" c="var(--text-dark)">
          {props.description}
        </Text>
        <Divider size="xs" color="var(--bg-500)" />

        <Group justify="space-between" wrap="nowrap">
          <Text fz={11} fw={700} c="var(--text-dark)" tt="uppercase">
            {i18n._('Prize pot')}
          </Text>
          <Box w={62}>
            <Text truncate="end" fz="xs" c="var(--text-green)" fw={700}>
              <NumberFormatter value={props.prizePot} prefix="$" thousandSeparator="," decimalScale={2} decimalSeparator="." fixedDecimalScale />
            </Text>
          </Box>
        </Group>

        <Group justify="space-between" wrap="nowrap">
          <Text fz={11} fw={700} c="var(--text-dark)" tt="uppercase">
            {i18n._('Creator')}
          </Text>

          <Group gap={4} justify="end">
            <Avatar src={props.userAvatar} size={14} />
            <Box w={45}>
              <Text truncate="end" fz={13} fw={500} c="var(--text-dark)">
                {props.username}
              </Text>
            </Box>
          </Group>
        </Group>

        <Button fz={11} fw={700} h={40} className={classes.root}>
          {i18n._('Join')}
        </Button>
      </Stack>
    </Card>;
};